var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"awsCostsChart"},[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',[_c('v-card-title',[_c('v-row',[_c('v-col',[_vm._v(_vm._s(_vm.chartTitle))])],1)],1),_c('chart-js-wrapper',{attrs:{"chartData":_vm.chartData,"options":_vm.chartOptions}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }